import * as types from '../Actions/actionTypes';
import initialState from './initialState';

export const cookiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.EXPIRE_COOKIE: {
            const c = {};
            c[action.key] = null;

            return Object.assign({}, state, c);
        }
        case types.SET_COOKIE: {
            const c = {};
            c[action.key] = action.value;

            return Object.assign({}, state, c);
        }
        default: return state;
    }
}